import React from 'react';

export const Check = () => {
  return (
    <svg aria-hidden width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.08977 11.3995L1.61072 6.92044L3.31921 5.21195L6.08977 7.98251L11.2769 2.79541L12.9854 4.5039L6.08977 11.3995Z"
        fill="#00AC3E"
      />
    </svg>
  );
};



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/FiveStarSurvey/components/Check.tsx